'use strict';

var toastr = require('toastr');
var GridSettingsService = function GridSettingsService(Restangular, GridSettings, ConfigurationLoaderService, ConfigurationService, $log) {
  function getDefaultGridSettings(gridId, gridMode) {
    var gridSettings = ConfigurationLoaderService.getGridSettings(gridId);
    return new GridSettings(gridSettings, gridMode);
  }
  function retrieveGridSettings(gridId, dynamicViewId) {
    var dynamicGridId = dynamicViewId && dynamicViewId !== 'default' ? [gridId, dynamicViewId].join(':') : gridId;
    var parameters = {
      gridId: dynamicGridId,
      username: ConfigurationService.getUserId()
    };
    return Restangular.one('grid').one('settings').get(parameters).then(transformResponse);
  }
  function transformResponse(response) {
    return new GridSettings(response);
  }
  function postGridColumns(gridSettings) {
    return Restangular.one('grid').one('settings').customPUT(gridSettings, 'configuration', {
      username: ConfigurationService.getUserId()
    }).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('GridSettingsService: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
  }
  return {
    getDefaultGridSettings: getDefaultGridSettings,
    retrieveGridSettings: retrieveGridSettings,
    postGridColumns: postGridColumns,
    transformResponse: transformResponse
  };
};
GridSettingsService.$inject = ['Restangular', 'GridSettingsFactory', 'ConfigurationLoaderService', 'ConfigurationService', '$log'];
module.exports = GridSettingsService;